var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"app-loader"}},[(_vm.loading)?_c('div',{staticClass:"AppLoaderCmp"},[_c('loader-cmp')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }